import { styled } from "@mui/material";
import MAccordion, { accordionClasses } from "@mui/material/Accordion";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { colors } from "@zapalacorp/tokens";

export const ChildAccordion = styled(MAccordion)(() => ({
  borderRadius: "8px !important",
  border: `1px solid ${colors.gray200}`,
  boxShadow: "none !important",
  overflow: "hidden",

  "&:before": {
    display: "none",
  },

  [`&.${accordionClasses.expanded}`]: {
    margin: "0 !important",
  },
}));

export const ChildAccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "8px 16px !important",
  backgroundColor: colors.gray50,

  [`&.${accordionSummaryClasses.root}`]: {
    minHeight: "56px !important",
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: "0 !important",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },

  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    color: colors.gray600,
  },
}));

export const ChildAccordionDetails = styled(MAccordionDetails)(() => ({
  padding: "16px !important",
  borderTop: `1px solid ${colors.gray200}`,
  backgroundColor: colors.white,

  display: "flex",
  flexDirection: "column",
  gap: "0px",
}));

export const SectionTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  color: colors.gray700,
  letterSpacing: "0.15px",
  marginLeft: "8px",
}));
